import get from 'lodash/get';

const bindValidationClasses = (node, {
  state,
  name,
  valid = 'valid',
  invalid = 'invalid',
  touched: touchClass = 'touched',
}) => state.subscribe(({ errors, touched }) => {
  const hasError = get(errors, name);
  const hasTouched = get(touched, name);

  if (hasError) {
    node.classList.remove(valid);
    node.classList.add(invalid);
  } else if (hasError !== undefined) {
    node.classList.add(valid);
    node.classList.remove(invalid);
  } else {
    node.classList.remove(valid);
    node.classList.remove(invalid);
  }

  if (hasTouched) {
    node.classList.add(touchClass);
  } else {
    node.classList.remove(touchClass);
  }
});

export function bindClass(node, params) {
  let unsubscribe = bindValidationClasses(node, params);
  return {
    update(params) {
      unsubscribe();
      unsubscribe = bindValidationClasses(node, params);
    },
    destroy() {
      unsubscribe();
    },
  };
}

export const isEmpty = val => [null, undefined, NaN, ''].includes(val)
  || Array.isArray(val) && !val.length;
